import React from 'react';
import PropTypes from 'prop-types';
import DropDown from '../../dropdown/DropDown';

const DropDownCell = ({ isNotEditable, dataString, dataStringClassName, dropDown }) =>
    isNotEditable ? (
        <div className={`display-container ${dataStringClassName}`}>
            <div className="display-value">{dataString || '- -'}</div>
        </div>
    ) : (
        <div className={`input-container ${dataStringClassName}`}>
            <DropDown {...dropDown} />
        </div>
    );

DropDownCell.defaultProps = {
    isNotEditable: false,
    dataString: null,
    dataStringClassName: '',
    dropDown: {},
};

DropDownCell.propTypes = {
    isNotEditable: PropTypes.bool,
    dataString: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dataStringClassName: PropTypes.string,
    dropDown: PropTypes.object,
};
export default DropDownCell;
